export default __webpack_public_path__ + "static/media/deen-label.9c4eb840.png";